import { PreventivoDTOStato } from '@framework/api-client';
import { currencyNumberFormatter } from '@framework/engine';
import { t } from '@framework/i18n';
import { ISODate } from '@framework/ui';
import { ColumnGroupType, ColumnType, ColumnsType } from 'antd/es/table';
import { Decimal } from 'decimal.js-light';
import React from 'react';
import { ISubmissionQuote } from './ISubmissionQuote';
import { QuoteStateTag } from './QuoteStateTag';

function formatCurrency(value: string | null | undefined) {
  return value != null
    ? currencyNumberFormatter.format(new Decimal(value).toNumber())
    : '- €';
}

type ColumnsBase<TDto> = Record<
  string,
  ColumnGroupType<TDto> | ColumnType<TDto>
>;

export const quoteColumnsBase = {
  descrizione: {
    title: t('quote-columns.descrizione', 'Descrizione'),
    dataIndex: 'descrizione',
    key: 'descrizione',
  },
  data: {
    title: t('quote-columns.data', 'Data'),
    dataIndex: 'dataCreazione',
    key: 'dataCreazione',
    render: date => <ISODate date={date} />,
  },
  numero: {
    title: t('quote-columns.numero', 'Numero'),
    dataIndex: 'numero',
    key: 'numero',
  },
  imponibile: {
    title: t('quote-columns.imponibile', 'Imponibile'),
    dataIndex: 'imponibile',
    key: 'imponibile',
    align: 'right',
    render: (_, record) => {
      const taxable = record.riepilogoVoci?.riepilogo.imponibile;
      return formatCurrency(taxable);
    },
  },
  iva: {
    title: t('quote-columns.iva', 'IVA'),
    dataIndex: 'iva',
    key: 'iva',
    align: 'right',
    render: (_, record) => {
      const vat = record.riepilogoVoci?.riepilogo.iva;
      return formatCurrency(vat);
    },
  },
  importo: {
    title: t('quote-columns.importo', 'Importo'),
    dataIndex: 'valore',
    key: 'valore',
    align: 'right',
    render: (_, record) => {
      const total = record.riepilogoVoci?.riepilogo.totale;
      return formatCurrency(total);
    },
  },
  stato: {
    title: t('quote-columns.stato', 'Stato'),
    dataIndex: 'stato',
    key: 'stato',
    render: (stato: PreventivoDTOStato) => <QuoteStateTag state={stato} />,
  },
} satisfies ColumnsBase<ISubmissionQuote>;

export const quoteColumns: ColumnsType<ISubmissionQuote> = [
  quoteColumnsBase.descrizione,
  // quoteColumnsBase.numero,
  quoteColumnsBase.stato,
  quoteColumnsBase.data,
  quoteColumnsBase.importo,
];
